import $ from 'jquery';

export default class Share {
    constructor() {
        if ($('.js-share').length) {
            $('body').on('click', '.js-share__toggle', function() {
                $(this).next().slideToggle();
            });
        };
    };
};
